module.exports = __webpack_public_path__ + "static/dark-corners-4790080483abc1012362428b519a25df.jpg";